<template>
  <div>
    <layout :hasBottom="false" :top="true">
      <div slot="head">
        <TopTabbar :hastitle="true" :title="title" />
      </div>
      <div slot="content" class="con">
        <swiper :options="swiperOptionh">
          <swiper-slide :style="'position: relative;'">
            <div class="imgwrap" :style="'width:'+imgheight+'rem;height:'+imgheight+'rem'">
              <van-swipe indicator-color="white" :show-indicators="false">
                <van-swipe-item v-for="(item,index) in imglist" :key="index">
                  <img :src="item | thumbnail(720,720)" />
                </van-swipe-item>
              </van-swipe>
            </div>
            <div class="upTips" :style="'top:'+(viewheight-100)+'px'">
              <!-- <img src="../../assets/img/up.png" class="up" /> -->
              <i class="iconfont iconzuo up" />
              <p>向上滑动详情</p>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div
              class="goodInfo"
              :style="'height:'+(viewheight-44)+'px;width:'+(viewheight-44)/1.11+'px;'"
              ref="goodInfo"
            >
              <div class="content_title">
                <p class="bigtitle">{{bigtitle}}</p>
                <p class="title">{{title}}</p>
              </div>
              <div class="content_text">
                <swiper :options="swiperOptionText" v-if="content!=''">
                  <swiper-slide class="text">
                    <div v-html="content" @click="showImg($event)"></div>
                  </swiper-slide>
                </swiper>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </layout>
  </div>
</template>
<script>
import TopTabbar from "@/components/TopTabbar.vue";
import layout from "@/components/layout.vue";
import { activeDetail } from "../../api/http.js";
import { Swipe, SwipeItem } from "vant";
import Vue from "vue";
Vue.use(Swipe).use(SwipeItem);
export default {
  components: {
    TopTabbar,
    layout
  },
  data() {
    return {
      bigtitle: "",
      title: "",
      imglist: [],
      content: "",
      id: "",
      active: 0,
      show: false,
      swiperOptionh: {
        direction: "vertical",
        loop: false,
        autoplay: false,
        initialSlide:1 
      },
      swiperOptionText: {
        direction: "vertical",
        slidesPerView: "auto",
        mousewheel: true,
        freeMode: true
      }
    };
  },
  computed: {
    imgheight() {
      return (this.$store.state.screenHeight - 44) / 102.4;
    },
    viewheight() {
      return this.$store.state.screenHeight;
    }
  },
  methods: {
    activeDetail(id) {
      activeDetail(id).then(res => {
        let data = res.data.data;
        this.title = data.title;
        this.bigtitle = data.ad.name;
        console.log(data);
        for (let i in data.image) {
          this.imglist.push(data.image[i].file_path);
        }
        this.content = data.content;
      });
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.activeDetail(this.id);
  }
};
</script>
<style lang="scss" scoped>
.con {
  height: 100%;
  background: url("../../assets/img/detailbg.jpg");
  background-size: 100%100%;
  overflow: hidden;
  position: fixed;
  width: 100%;
  .imgwrap {
    margin: 0px auto;
    img {
      height: 100%;
      width: 100%;
    }
  }
}
@keyframes scrollToUp {
  0% {
    transform: translateY(0px);
  }
  25% {
    transform: translateY(-5px);
  }
  50% {
    transform: translateY(0px);
  }
  75% {
    transform: translateY(-5px);
  }
  100% {
    transform: translateY(0px);
  }
}
.upTips {
  position: fixed;
  bottom: 16px;
  width: 100px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  .up {
    display: block;
    margin: 0px auto;
    width: 16px;
    height: 16px;
    animation: scrollToUp 5s linear infinite;
    font-size: 12px;
    color: #fff;
  }
  p {
    display: block;
    margin: 0px;
    font-size: 12px;
    color: #fff;
    text-align: center;
  }
}
.goodInfo {
  margin: 0px auto;
  z-index: 20;
  width: 100%;
  height: 100%;
  background: url("../../assets/img/bg2.png");
  background-size: 100%100%;
  padding: 20px 50px 60px 50px;
  box-sizing: border-box;
  overflow: hidden;
  .content_title {
    border-bottom: 1px solid #c9a864;
    font-size: 20px;
    line-height: 26px;
    text-align: center;
    color: #c9a864;
    .bigtitle {
      font-size: 20px;
      color: #c9a864;
      text-align: center;
      margin: 20px;
    }
    .title {
      font-size: 16px;
      color: #c9a864;
      text-align: center;
      margin: 20px;
    }
  }
  .content_text {
    height: calc(100% - 116px);
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    margin-top: 10px;
  }
}
</style>
<style>
.content_text p {
  margin: 0px;
  font-size: 14px;
  color: #c9a864;
}
.content_text img {
  width: 100%;
}
.content_text .swiper-container{
  height: 100%;
}
.content_text .text{
  height: auto !important;
}
</style>


